import { standardGridPageSize, customAutoCompleteFilter } from "../../GlobalVariables/filterVariables";

export default /*@ngInject*/ function ($uibModalInstance, $filter, helperService, userRolesDataService, dataService, productId, selectedProducts, requestAction, excludeRoles, objectTypeName, daaEnabled) {

    var vm = this;
    vm.cancel = cancel;
    vm.close = close;
    vm.changeUserRowSelected = changeUserRowSelected;
    vm.productId = productId;
    vm.selectedProducts = selectedProducts;
    vm.requestAction = requestAction;
    vm.excludeRoles = excludeRoles;
    vm.objectTypeName = objectTypeName;
    vm.daaEnabled = daaEnabled || false;
    vm.includeDataAccessAssignments = false;

    function activate() {
        configureUsersGrid();
    }

    activate();

    function cancel() { $uibModalInstance.dismiss(); }

    function close(selectedUser) {
        selectedUser.keepCurrent = vm.keepCurrentRoles || false;
        selectedUser.includeDataAccessAssignments = vm.includeDataAccessAssignments || false;
        $uibModalInstance.close(selectedUser);
    }

    function configureUsersGrid() {
        const usersGridColumns = [
            { title: "Name", field: "Name", filterable: customAutoCompleteFilter },
            { title: "Id", field: "ID", filterable: customAutoCompleteFilter },
            { title: "Description", field: "Description", filterable: customAutoCompleteFilter }
        ];

        vm.usersGridOptions = helperService.setMainGridOptions(usersGridColumns, null);

        vm.usersGridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            transport: {
                read: async options => {
                    let allUsers = [];

                    // Handle multiple selected products
                    if (vm.selectedProducts && Array.isArray(vm.selectedProducts) && vm.selectedProducts.length > 0) {
                        // Fetch users for each selected product
                        const userPromises = vm.selectedProducts.map(product =>
                            userRolesDataService.getUsers(product.ID)
                        );
                        const responses = await Promise.all(userPromises);

                        // Merge users from all products, removing duplicates by ID
                        const userMap = new Map();
                        responses.forEach(response => {
                            response.data.forEach(user => {
                                if (!userMap.has(user.ID)) {
                                    userMap.set(user.ID, user);
                                }
                            });
                        });
                        allUsers = Array.from(userMap.values());
                    }
                    // Handle single product (backwards compatibility)
                    else if (vm.productId) {
                        const response = await userRolesDataService.getUsers(vm.productId);
                        allUsers = response.data;
                    }
                    // No product selected - get all users
                    else {
                        const response = await dataService.getUserMaster();
                        allUsers = response.data;
                    }

                    allUsers = $filter('orderBy')(allUsers, 'Name');
                    options.success(allUsers);
                }
            }
        });
    }

    function changeUserRowSelected(kendoEvent) {
        var grid = kendoEvent.sender;
        vm.selectedUser = grid.dataItem(grid.select());
    }
}